import styled from 'styled-components';
import { LinkColors, LinkProps, LinkDecorationTypes } from './link.types';
import { MLBTheme } from '../../style/theme.types';

const { DOTTED } = LinkDecorationTypes;

const retrieveColorTheme = (theme: MLBTheme | undefined, type: string | undefined, prop: string): string => {
  const dark = (theme && theme.dark) || false;
  const colorTheme = dark ? 'dark' : type || 'primary';
  return LinkColors[colorTheme as keyof typeof LinkColors][prop];
};

type AnchorElementProps = Omit<LinkProps, 'url'>;

export const AnchorElement = styled.a<AnchorElementProps>`
  color: ${(props) => retrieveColorTheme(props.theme, props.type, 'base')};
  text-decoration: ${(props) => (!(props.decoration === DOTTED) ? props.decoration : 'none')};
  border-bottom: ${(props) =>
    props.decoration === DOTTED ? `1px dotted ${retrieveColorTheme(props.theme, props.type, 'base')}` : 'none'};
  font-family: ${(props) => props.theme?.fonts?.family?.primary};

  &:hover {
    border-bottom: ${(props) =>
      props.decoration === DOTTED ? `1px dotted ${retrieveColorTheme(props.theme, props.type, 'hover')}` : 'none'};
    color: ${(props) => retrieveColorTheme(props.theme, props.type, 'hover')};
  }
`;
